<template lang="html">
  <a @click="goBack"><slot></slot></a>
</template>
<script type="text/javascript">
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
